module.exports = __webpack_public_path__ + "static/img/lineBlueText.a36d5b0d.png";